import { gql } from '@apollo/client/core'

import { PAGE_INFO_ATTRIBUTES } from './fragments'

export const DAMAGE_INFO_INDEX_QUERY = gql`
  query damageInfos(
    $first: Int
    $last: Int
    $offset: Int
    $after: String
    $before: String
    $machineIds: [ID!]
    $rentalId: ID
    $rentalCode: String
    $sort: [SortOptions!] = [{ sortField: "created_at", sortDirection: "desc" }]
  ) {
    damageInfos(
      first: $first
      last: $last
      offset: $offset
      after: $after
      before: $before
      machineIds: $machineIds
      rentalId: $rentalId
      rentalCode: $rentalCode
      sort: $sort
    ) {
      nodes {
        id
        damageNumber
        machineName
        damageStage
        damageTime
        description
        damagePaymentTotal
        deductible
        machineState
        perpetrator
        damageCircumstances
        damageItem {
          id
          name
        }
      }
      pageInfo {
        ...pageInfoAttributes
      }
      totalCount
      maxPageSize
      pageIndex
    }
  }
  ${PAGE_INFO_ATTRIBUTES}
`
